import I18n from '@utils/i18n.utils';
import {globalWeekDays} from '@utils/dayjs.utils';

export enum ScheduleFrequency {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
}

export namespace ScheduleFrequency {
  export const selectItems = () => [
    {label: I18n.t('global.frequencies.daily'), value: ScheduleFrequency.DAILY},
    {label: I18n.t('global.frequencies.weekly'), value: ScheduleFrequency.WEEKLY},
    {label: I18n.t('global.frequencies.monthly'), value: ScheduleFrequency.MONTHLY},
  ];
}

export enum NumeralDayOfMonth {
  FIRST = 'FIRST',
  SECOND = 'SECOND',
  THIRD = 'THIRD',
  FOURTH = 'FOURTH',
  LAST = 'LAST',
}

export function getNumeralDayOfMonthTranslation(value: NumeralDayOfMonth) {

  switch (value) {
    case NumeralDayOfMonth.FIRST:
      return I18n.t('global.numeralDayOfMonth.first');
    case NumeralDayOfMonth.SECOND:
      return I18n.t('global.numeralDayOfMonth.second');
    case NumeralDayOfMonth.THIRD:
      return I18n.t('global.numeralDayOfMonth.third');
    case NumeralDayOfMonth.FOURTH:
      return I18n.t('global.numeralDayOfMonth.fourth');
    case NumeralDayOfMonth.LAST:
      return I18n.t('global.numeralDayOfMonth.last');
    default:
      return I18n.t('global.numeralDayOfMonth.last');
  }
}


export namespace NumeralDayOfMonth {
  export const selectItems = () => [
    {label: I18n.t('global.numeralDayOfMonth.first'), value: NumeralDayOfMonth.FIRST},
    {label: I18n.t('global.numeralDayOfMonth.second'), value: NumeralDayOfMonth.SECOND},
    {label: I18n.t('global.numeralDayOfMonth.third'), value: NumeralDayOfMonth.THIRD},
    {label: I18n.t('global.numeralDayOfMonth.fourth'), value: NumeralDayOfMonth.FOURTH},
    {label: I18n.t('global.numeralDayOfMonth.last'), value: NumeralDayOfMonth.LAST},
  ];
}

export function getWeekDayTranslation(value: WeekDay) {
  switch (value) {
    case WeekDay.MONDAY:
      return globalWeekDays[0];
    case WeekDay.TUESDAY:
      return globalWeekDays[1];
    case WeekDay.WEDNESDAY:
      return globalWeekDays[2];
    case WeekDay.THURSDAY:
      return globalWeekDays[3];
    case WeekDay.FRIDAY:
      return globalWeekDays[4];
    case WeekDay.SATURDAY:
      return globalWeekDays[5];
    case WeekDay.SUNDAY:
      return globalWeekDays[6];
    default:
      return globalWeekDays[0];
  }
}

export function getWeekDayListFromString(days: string) {
  const array = days.split(',');
  const filteredArray = array.filter(item => item !== '');
  const formatted = filteredArray.map((day) => getWeekDayTranslationFromString(day));
  return formatted.join(', ');

}

export function getWeekDayTranslationFromString(value: string) {
  switch (value) {
    case 'lun.':
      return globalWeekDays[0];
    case 'mar.':
      return globalWeekDays[1];
    case 'mer.':
      return globalWeekDays[2];
    case 'jeu.':
      return globalWeekDays[3];
    case 'ven.':
      return globalWeekDays[4];
    case 'sam.':
      return globalWeekDays[5];
    case 'dim.':
      return globalWeekDays[6];
    default:
      return globalWeekDays[0];
  }
}

export enum WeekDay {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

export namespace WeekDay {
  export const weekDays = [
    WeekDay.MONDAY, WeekDay.TUESDAY, WeekDay.WEDNESDAY, WeekDay.THURSDAY, WeekDay.FRIDAY, WeekDay.SATURDAY, WeekDay.SUNDAY
  ];

  export const selectItems = globalWeekDays.map((day, index) => ({label: day, value: weekDays[index]}));
}

export interface ManageSchedule extends Partial<Schedule> {
  wasUpdated?: boolean;
  startFrom?: Date;
  endFrom?: Date;
}

export interface Schedule {
  id: number;
  name: string;
  theoreticalQuantity: number;
  frequency?: ScheduleFrequency;
  monthlyFrequencyNumber: number;
  weeklyFrequencyNumber: number;
  dailyFrequencyNumber: number;
  dailyEveryWeekDay: boolean;
  daysOfWeek: number[];
  isDayOfMonth: boolean;
  dayOfMonth: number;
  numeralDayOfMonth: NumeralDayOfMonth;
  weekDayForMonth: WeekDay;
  fromDate: Date;
  toDate: Date;
  numberOfOccurrencesAhead?: number;
  startHour: number;
  endHour: number;
  startMinutes: number;
  endMinutes: number;
}
